module.exports = __webpack_public_path__ + "static/media/amish.9be5a463.jpg";